export default theme => ({
  preview: {
    marginTop: theme.spacing(5),
  },
});
